var _a, _b;
import { SearchDocumentType } from '../sdk.types';
import { DocumentParser } from './documentParser';
import * as messagesEn from '../../assets/locales/messages_en.json';
var DOCUMENT_TYPE_TITLE_TRANSLATIONS = (_a = {},
    _a[SearchDocumentType.All] = 'documentType.title.all',
    _a[SearchDocumentType.Pages] = 'documentType.title.pages',
    _a[SearchDocumentType.Products] = 'documentType.title.products',
    _a[SearchDocumentType.Blogs] = 'documentType.title.blogs',
    _a[SearchDocumentType.Forums] = 'documentType.title.forums',
    _a[SearchDocumentType.Bookings] = 'documentType.title.bookings',
    _a[SearchDocumentType.Events] = 'documentType.title.events',
    _a[SearchDocumentType.Programs] = 'documentType.title.programs',
    _a[SearchDocumentType.ProGallery] = 'documentType.title.proGallery',
    _a);
var DOCUMENT_TYPE_TRENDING_TRANSLATIONS = (_b = {},
    _b[SearchDocumentType.Pages] = 'documentType.trending.pages',
    _b[SearchDocumentType.Products] = 'documentType.trending.products',
    _b[SearchDocumentType.Blogs] = 'documentType.trending.blogs',
    _b[SearchDocumentType.Forums] = 'documentType.trending.forums',
    _b[SearchDocumentType.Bookings] = 'documentType.trending.bookings',
    _b[SearchDocumentType.Events] = 'documentType.trending.events',
    _b[SearchDocumentType.Programs] = 'documentType.trending.programs',
    _b[SearchDocumentType.ProGallery] = 'documentType.trending.proGallery',
    _b);
function groupBy(array, key) {
    return array.reduce(function (objectsByKeyValue, obj) {
        var keyValue = key(obj);
        objectsByKeyValue[keyValue] = (objectsByKeyValue[keyValue] || []).concat(obj);
        return objectsByKeyValue;
    }, {});
}
function initTranslations(language) {
    var messages = messagesEn;
    try {
        messages = require("../../assets/locales/messages_".concat(language, ".json"));
    }
    catch (e) {
        //
    }
    function getDocumentTypeTitle(documentType) {
        var key = DOCUMENT_TYPE_TITLE_TRANSLATIONS[documentType];
        if (!key) {
            return documentType;
        }
        return messages[key] || messagesEn[key] || documentType;
    }
    function getDocumentTypeTrendingTitle(documentType) {
        if (documentType === SearchDocumentType.All) {
            return documentType;
        }
        var key = DOCUMENT_TYPE_TRENDING_TRANSLATIONS[documentType];
        if (!key) {
            return documentType;
        }
        return messages[key] || messagesEn[key] || documentType;
    }
    return { getDocumentTypeTitle: getDocumentTypeTitle, getDocumentTypeTrendingTitle: getDocumentTypeTrendingTitle };
}
var SuggestionsParser = /** @class */ (function () {
    function SuggestionsParser(siteBaseUrl, language) {
        this.documentParser = new DocumentParser(siteBaseUrl);
        var _a = initTranslations(language), getDocumentTypeTitle = _a.getDocumentTypeTitle, getDocumentTypeTrendingTitle = _a.getDocumentTypeTrendingTitle;
        this.getDocumentTypeTitle = getDocumentTypeTitle;
        this.getDocumentTypeTrendingTitle = getDocumentTypeTrendingTitle;
    }
    SuggestionsParser.prototype.parse = function (suggestions) {
        var _this = this;
        var grouped = groupBy(suggestions, function (v) { return v.documentType; });
        var parse = function (document) {
            return _this.documentParser.parse(document);
        };
        var groupedSuggestions = Object.keys(grouped).map(function (documentType) { return ({
            title: _this.getDocumentTypeTitle(documentType),
            documentType: documentType,
            options: grouped[documentType].map(parse),
        }); });
        return groupedSuggestions;
    };
    return SuggestionsParser;
}());
export { SuggestionsParser };
//# sourceMappingURL=SuggestionsParser.js.map